import {getClassList} from "../../../Utility/siteConfig";

export default function CheckToCompare({id, selected, handleSelect}) {
  // HIDDEN on mobile, due to the wrapper class.
  let className = getClassList({
    key: 'CheckToCompare',
    fallback: "mt-2 relative font-normal text-sm text-center",
    base: "hidden lg:block"
  })

  let inputClasses = getClassList({
    key: 'CompareItems.checkbox',
    fallback: 'mx-2'
  })

  return (
    <label className={className}>
      <input id={id} type="checkbox" value="1"
        className={inputClasses}
        onChange={handleSelect} checked={selected}/>

      <span>Check to Compare</span>
    </label>
  );
}
